import Button from 'Components/UI_Library/FormElements/Button';
import classes from '../MFA.module.css';
import InputMask from 'react-input-mask';
import InputError from 'Components/UI_Library/FormElements/InputError';
import { Link } from 'react-router-dom';
import { ChangeEvent } from 'react';
import inputClasses from 'Components/UI_Library/FormElements/Inputs.module.css';

const SMSMFA = ({
    phoneNumber,
    code,
    loadingSMS,
    isFirstSend,
    errors,
    exitForm,
    handleVerifySMSCode,
    handleSendSMSCode,
    setCode,
}: {
    phoneNumber: string;
    code: string;
    loadingSMS: boolean;
    isFirstSend: boolean;
    errors: { code?: string; TOTPCode?: string };
    exitForm: () => void;
    handleVerifySMSCode: () => void;
    handleSendSMSCode: () => void;
    setCode: (code: string) => void;
}) => (
    <div className={classes.authSMSForm}>
        <div className={classes.formHeading}>
            <h5>Follow the steps below</h5>
            <Button type="white-condensed" onClick={() => exitForm()} text="Go back" />
        </div>
        <div className={classes.enableAuthApp}>
            <div className={classes.step}>
                <h5>1</h5>
                {phoneNumber ? (
                    <>
                        <p>Your phone number:</p>
                        <p style={{ paddingBottom: '20px' }}>
                            <strong>{phoneNumber}</strong>
                        </p>
                        <Button
                            testId="SMS-test-submit"
                            type="white-condensed"
                            onClick={() => handleSendSMSCode()}
                            loading={loadingSMS}
                            disabled={loadingSMS}
                            text={!isFirstSend ? 'Send code' : 'Resend'}
                        />
                    </>
                ) : (
                    <>
                        <p>
                            Your phone number is not linked, please{' '}
                            <Link to="/setup/user/edit">complete your account</Link>.
                        </p>
                    </>
                )}
            </div>
            <div className={errors.code ? `${classes.step} ${classes.error}` : classes.step}>
                <h5>2</h5>
                <label>Verification code:</label>
                <InputMask
                    name="code"
                    placeholder="------"
                    value={code || ''}
                    className={inputClasses.generalTextInput}
                    style={{ textAlign: 'center' }}
                    mask="999999"
                    maskChar={null}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCode(e.target.value)}
                />
                <InputError error={errors.code} />

                <Button
                    type="primary"
                    onClick={() => handleVerifySMSCode()}
                    text="Verify"
                    loading={loadingSMS}
                    disabled={loadingSMS}
                />
            </div>
        </div>
    </div>
);

export default SMSMFA;
